import { Show } from "@/shared/components/control";
import { site } from "@/config/site";
import { CatMark, LanguageSwitch, TelegramLogo, TextLink, XLogo } from "@/shared/components/ui";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export function SiteHeader() {
  const { t } = useTranslation();
  const { brand, links } = site;
  const showInstagram = Boolean(links.instagram?.trim());

  return (
    <header className="fixed top-0 left-0 right-0 z-[100] border-b border-border-soft/60 bg-canvas/65 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-5xl items-center justify-between gap-4 px-[clamp(16px,4vw,40px)] sm:max-w-none lg:px-[clamp(24px,5vw,64px)]">
        <Link
          to={links.homePath}
          className="group flex min-w-0 items-center gap-2.5 rounded-md outline-offset-4 transition-opacity hover:opacity-90 sm:gap-3"
          aria-label={t("header.homeAria", { brand })}
        >
          <CatMark
            decorative
            className="h-7 w-7 shrink-0 text-accent transition-colors duration-200 group-hover:text-ink sm:h-8 sm:w-8"
          />
          <span className="min-w-0 truncate font-brand text-[1.35rem] font-normal leading-none tracking-[-0.02em] text-ink italic sm:text-[1.5rem]">
            {brand}
          </span>
        </Link>
        <nav
          className="flex shrink-0 items-center gap-3 sm:gap-5"
          aria-label={t("nav.ariaLabelMain")}
        >
          <LanguageSwitch />
          <TextLink
            to={links.twitter}
            external
            variant="icon"
            aria-label={t("nav.twitter")}
          >
            <XLogo decorative />
          </TextLink>
          <Show when={showInstagram}>
            <TextLink to={links.instagram} external>
              {t("nav.instagram")}
            </TextLink>
          </Show>
          <TextLink
            to={links.telegram}
            external
            variant="icon"
            aria-label={t("nav.telegram")}
          >
            <TelegramLogo decorative />
          </TextLink>
        </nav>
      </div>
    </header>
  );
}
